import { WordPressService } from '@xq/infrastructure';

export class FetchXQDescriptionUseCase {
  wordPressService: WordPressService;

  constructor() {
    this.wordPressService = WordPressService.getInstance();
  }

  async execute() {
    return this.wordPressService.fetchXQDescription();
  }
}
